import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Button,
  Label,
  makeStyles,
  tokens,
  useToastController,
  useId,
  Toaster,
} from "@fluentui/react-components";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux/store";

import { getCaseCategoryByCaseType } from "../../../../utils";
import CaseNavList from "../CaseNavList";
import CaseForm from "../CaseForm";
import CaseList from "../CaseList";
import ContentLoader from "../../../../components/Loader/ContentLoader";
import ModalDialog from "../../../../components/ModalDialog";
import CaseDetailDrawer from "../CaseDetailDrawer";
import {
  getPolicyDetailById,
  getPolicyValuationDetailById,
  getPolicyValuationsListItems,
} from "../../../../redux/Case/policySlice";
import { useToastMessage } from "../../../../components/ToastMessage/ToastMessage";
import NoDataFound from "../../../../components/NoDataFound/noDataFound";

const useStyles = makeStyles({});

function PolicyValuations({ tab }: { tab: string }) {
  const navigate = useNavigate();
  const styles = useStyles();
  const { showToast, toasterId } = useToastMessage();
  const { clientId, action, caseId, subItemId } = useParams();
  const dispatch: AppDispatch = useDispatch();
  const [currentRecord, setCurrentRecord] = useState(1);

  const formSettingsObj = useSelector((state: RootState) => state.formSettings);
  const policies = useSelector((state: RootState) => state.policies);
  const dialogModalOptions = useSelector((state: RootState) => state.dialog);

  const [caseType, setCaseType] = useState<string>("");
  const [isOpen, setIsOpen] = useState(false);
  const handleDetailPopup = (action: boolean) => {
    setIsOpen(action);
  };
  useEffect(() => {
    if (caseId && clientId) {
      dispatch(getPolicyDetailById({ id: caseId, customerId: clientId }));
      dispatch(
        getPolicyValuationsListItems({ id: caseId, customerId: clientId })
      );
    }
  }, [caseId, clientId, dispatch]);

  useEffect(() => {
    if (policies?.activeItem?.case_type) {
      setCaseType(getCaseCategoryByCaseType(policies.activeItem.case_type));
    }
  }, [policies?.activeItem]);

  const valuationId =
    subItemId || policies.valuations.listItems[0]?.valuation_id;
  useEffect(() => {
    if (!caseId || !valuationId) return;
    if (action === "view") {
      navigate(
        `/clients/${clientId}/policies/${caseId}/valuations/${valuationId}/valuation/view`
      );
    } else if (action === "add") {
      navigate(`/clients/${clientId}/policies/${caseId}/valuation/add`);
    } else if (action === "edit") {
      navigate(
        `/clients/${clientId}/policies/${caseId}/valuations/${valuationId}/valuation/edit`
      );
    } else {
      navigate(
        `/clients/${clientId}/policies/${caseId}/valuations/${valuationId}/valuation/view`
      );
    }
  }, [
    clientId,
    action,
    caseId,
    policies.valuations.listItems,
    valuationId,
    navigate,
    tab,
  ]);

  useEffect(() => {
    if (subItemId) {
      dispatch(getPolicyValuationDetailById(subItemId));
    }
  }, [subItemId, dispatch, policies.valuations.listItems]);

  return (
    <div>
      <Toaster toasterId={toasterId} position="top-end" timeout={5000} />
      <CaseNavList
        subItem="valuations"
        section="policies"
        tab={tab}
        caseType={caseType}
        caseDetail={policies?.valuations.activeItem}
        handleDetailPopup={handleDetailPopup}
      />
      <div className="case_container_flex">
        <CaseForm
          mode={action || ""}
          section="policies"
          caseType={caseType}
          caseDetail={policies?.valuations.activeItem}
          caseItemList={policies?.valuations.listItems}
          tab={tab}
          subItem="valuations"
          notify={showToast}
          currentRecord={currentRecord}
          setCurrentRecord={setCurrentRecord}
        />
        <div>
          {policies?.valuations.loading ? (
            <ContentLoader />
          ) : (
            <>
              {policies?.valuations.listItems.length > 0 && (
                <CaseList
                  module="valuations"
                  data={policies?.valuations.listItems}
                  activeItem={policies?.valuations.activeItem}
                  section="policies"
                  activeTab={tab}
                  currentRecord={currentRecord}
                  setCurrentRecord={setCurrentRecord}
                />
              )}
              {!action && policies?.valuations.listItems.length === 0 && (
                <NoDataFound />
              )}
            </>
          )}
        </div>
      </div>
      <CaseDetailDrawer
        isOpen={isOpen}
        caseDetail={policies?.activeItem}
        handleDetailPopup={handleDetailPopup}
      />
      <ModalDialog options={dialogModalOptions} />
    </div>
  );
}

export default PolicyValuations;
